import { obterDepartamentosAsync } from "../../services/departamentoService";

const atualizarDepartamentos = async ({ commit }) => {
    const departamentos = await obterDepartamentosAsync();
    commit('atualizarDepartamentos', departamentos);
}

const atualizarDepartamento = ({ commit }, departamento) => {
    commit('atualizarDepartamento', departamento);
}

const addDepartamento = ({ commit }, departamento) => {
    commit('addDepartamento', departamento);
}

const updateDepartamento = ({ commit }, departamento) => {
    commit('updateDepartamento', departamento);
}

export default {
    atualizarDepartamentos,
    atualizarDepartamento,
    addDepartamento,
    updateDepartamento
}
